// extend the zoombox class
import axios from 'axios';
import {TheZoombox} from '../vendor/the-zoombox';

/**
 * @deprecated
 */
export class TheZoomboxSbr extends TheZoombox {
  // extend constructor to add new options
  constructor(containerSelector, options) {
    super(containerSelector, options);
  }

  createOverlay() {
    super.createOverlay();

    // HTML-Struktur anpassen
    const overlay = this.overlay;

    if (this.options.sidebar) {
      overlay.classList.add('has-sidebar');
      this.sidebar = document.createElement('div');
      this.sidebar.classList.add('zoombox-sidebar');
      overlay.appendChild(this.sidebar);
    }
  }

  showItem(index) {
    super.showItem(index);

    if (this.options.sidebar && this.sidebar) {
      if (this.options.ajaxInfo) {
        this.loadAjaxInfo();
      } else {
        // caption
        let sidebarHtml = '';
        if (this.options.showPictureCounter) {
          sidebarHtml += '<div><strong>' + (index + 1) + '/' + this.items.length + '</strong></div>';
        }
        if (this.options.showCaption && this.items[this.activeIndex].caption) {
          sidebarHtml += this.items[this.activeIndex].caption.replace(/\n/g, '<br>');
        }
        this.sidebar.innerHTML = sidebarHtml;

        // hide default caption and picture counter
        this.overlay?.querySelector('.zoombox-caption')?.remove();
        this.overlay?.querySelector('.zoombox-counter')?.remove();
      }
    }
  }

  loadAjaxInfo() {
    if(this.sidebar && this.options.ajaxInfo && this.items[this.activeIndex].dataUid) {
      const sidebar = this.sidebar;

      axios.get(this.options.ajaxInfo, {
        params: {
          uid: this.items[this.activeIndex].dataUid,
        },
      }).then(function(response) {
        window.executeInnerHTML(sidebar, response.data);
      }).catch(function(error) {
        console.log(error);
      }).finally(function() {
        // always executed
      });
    }
  }
}
